// extracted by mini-css-extract-plugin
export var cartContainer = "_n3-4";
export var gray = "_n3-1";
export var itemContainer = "_n3-2";
export var itemDetails = "_n3-3";
export var strong = "_n3-0";